import { Controller } from '@hotwired/stimulus';
import {
  eventListener,
  observer,
} from '@inked/utilities';

export class DialogController extends Controller {
  static targets = ['dialog'];
  static values = {
    modal: {
      default: true,
      type: Boolean,
    },
    open: {
      default: false,
      type: Boolean,
    },
    removeOnClose: {
      default: false,
      type: Boolean,
    },
    triggerSelector: String,
  };

  connect() {
    if (this.openValue) {
      this.open();
    }

    if (this.triggerSelectorValue) {
      this.stopTriggerSelectorClickEvents = eventListener(
        this.triggerSelectorValue,
        'click',
        () => this.onTriggerSelectorClick(),
      );

      this.stopTriggerSelectorObserver = observer(
        document.body,
        'mutation',
        mutations => {
          for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType !== Node.ELEMENT_NODE) continue;

              if (node.matches(this.triggerSelectorValue)) {
                eventListener(node, 'click', () => this.onTriggerSelectorClick());

                continue;
              }

              [...node.querySelectorAll(this.triggerSelectorValue)].forEach(childNode => {
                eventListener(childNode, 'click', () => this.onTriggerSelectorClick());
              });
            }
          }
        },
        {
          childList: true,
          subtree: true,
        },
      );
    }
  }

  disconnect() {
    if (this.triggerSelectorValue) {
      this.stopTriggerSelectorClickEvents();
      this.stopTriggerSelectorObserver();
    }
  }

  onTriggerSelectorClick() {
    this.open();
  }

  open() {
    this.dispatch('beforeopen');

    this.modalValue ? this.dialogElement.showModal() : this.dialogElement.show();
  }

  close() {
    this.dispatch('beforeclose');

    this.dialogElement.close();

    if (this.removeOnCloseValue) this.element.remove();
  }

  get dialogElement() {
    return this.hasDialogTarget ? this.dialogTarget : this.element;
  }
}
